export const GET_USER_LOG_LIST_REQUEST = "GET_USER_LOG_LIST_REQUEST"
export const GET_USER_LOG_LIST_SUCCESS = "GET_USER_LOG_LIST_SUCCESS"
export const CLEAR_USER_LOG_LIST = "CLEAR_USER_LOG_LIST"
export const DELETE_USER_LOG_REQUEST = "DELETE_USER_LOG_REQUEST"
export const DELETE_USER_LOG_SUCCESS = "DELETE_USER_LOG_SUCCESS"
